import { useQuery } from "@tanstack/react-query";
import type { TrustpilotRating } from "@/services/TrustpilotClient";

export const trustpilotRatingQueryKey = ["trustpilot-rating"];

export const useTrustpilotRating = () =>
  useQuery<TrustpilotRating | null>({
    queryKey: trustpilotRatingQueryKey,
    staleTime: 3_600_000,
    queryFn: async () => {
      const res = await fetch("/api/trustpilot/rating");
      if (!res.ok) return null;
      return res.json();
    },
  });
